// extracted by mini-css-extract-plugin
export var gif = "_h8-0";